/**
 * Account Model - Processes API responses for account data
 */

/**
 * Process account creation response
 * @param {Object} response - API response from account create endpoint
 * @returns {Object} Formatted creation response
 */
export const accountCreatePost = (response) => {
    // Based on Postman collection response format
    if (response && response.data) {
        return {
            success: response.data.success === true,
            message: response.data.message || 'Account created successfully',
            data: response.data.data || null
        };
    }
    return {
        success: false,
        message: 'Failed to create account',
        data: null
    };
};

/**
 * Account list response data
 * @param {Object} response - API response from account list endpoint
 * @returns {Object} Account list data
 */
export const accountListGet = (response) => {
    // Based on Postman collection response format
    if (response && response.data && response.data.success === true) {
        return {
            success: true,
            total: response.data.total || response.data.data.length,
            data: response.data.data
        };
    }
    return {
        success: false,
        message: response?.data?.message || 'Failed to fetch account list',
        data: []
    };
};

/**
 * Account type list response data
 * @param {Object} response - API response from account type list endpoint
 * @returns {Object} Account type list data
 */
export const accountTypeListGet = (response) => {
    // Based on Postman collection response format
    if (response && response.data && response.data.success === true) {
        return {
            success: true,
            total: response.data.total || response.data.data.length,
            data: response.data.data
        };
    }
    return {
        success: false,
        message: response?.data?.message || 'Failed to fetch account type list',
        data: []
    };
};

/**
 * Process single account details response
 * @param {Object} response - API response from account details endpoint
 * @returns {Object} Formatted account details
 */
export const accountDetailsGet = (response) => {
    // Based on Postman collection response format
    if (response && response.data && response.data.success === true) {
        const item = response.data.data || {};
        return {
            success: true,
            data: item
        };
    }
    return {
        success: false,
        message: response?.data?.message || 'Failed to fetch account details',
        data: {}
    };
};

/**
 * Process account update response
 * @param {Object} response - API response from account update endpoint
 * @returns {Object} Formatted update response
 */
export const accountUpdatePut = (response) => {
    // Based on Postman collection response format
    if (response && response.data) {
        return {
            success: response.data.success === true,
            message: response.data.message || 'Account updated successfully',
            data: response.data.data || null
        };
    }
    return {
        success: false,
        message: 'Failed to update account',
        data: null
    };
};

/**
 * Process account delete response
 * @param {Object} response - API response from account delete endpoint
 * @returns {Object} Formatted delete response
 */
export const accountDeleteDel = (response) => {
    // Based on Postman collection response format
    if (response && response.data) {
        return {
            success: response.data.success === true,
            message: response.data.message || 'Account deleted successfully'
        };
    }
    return {
        success: false,
        message: 'Failed to delete account'
    };
};